import React, { Fragment, useMemo } from 'react'

const RADIUS = 76
const STROKE = 22
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

const SEGMENTS = [
    { key: 'planifie', label: 'Planifié', color: '#8a94a6' },
    { key: 'enCours', label: 'En cours', color: '#fb6340' },
    { key: 'termine', label: 'Terminé', color: '#1cbcb4' },
]

function StatusRing({ data }) {
    const total = (data?.planifie || 0) + (data?.enCours || 0) + (data?.termine || 0)

    const arcs = useMemo(() => {
        let offset = 0
        return SEGMENTS.map(seg => {
            const value = data?.[seg.key] || 0
            const fraction = total > 0 ? value / total : 0
            const length = fraction * CIRCUMFERENCE
            const arc = { ...seg, value, length, offset }
            offset += length
            return arc
        })
        // eslint-disable-next-line
    }, [data, total])

    if(total === 0) {
        return (
            <Fragment>
                <p className='emptyState'>Aucune opération enregistrée pour l’instant.</p>
            </Fragment>
        )
    }

  return (
    <Fragment>
        <div className='statusRing'>
            <svg viewBox='0 0 200 200' width='200' height='200'>
                <circle cx='100' cy='100' r={RADIUS} fill='none' stroke='#EDF1F1' strokeWidth={STROKE} />
                {arcs.map(arc => (
                    <circle
                        key={arc.key}
                        cx='100' cy='100' r={RADIUS} fill='none'
                        stroke={arc.color}
                        strokeWidth={STROKE}
                        strokeDasharray={`${arc.length} ${CIRCUMFERENCE - arc.length}`}
                        strokeDashoffset={-arc.offset}
                        transform='rotate(-90 100 100)'
                    />
                ))}
                <text x='100' y='96' textAnchor='middle' className='ringTotal'>{total}</text>
                <text x='100' y='118' textAnchor='middle' className='ringLabel'>opérations</text>
            </svg>
            <ul className='ringLegend'>
                {arcs.map(arc => (
                    <li key={arc.key}>
                        <span className='dot' style={{ backgroundColor: arc.color }}></span>
                        <span className='label'>{arc.label}</span>
                        <span className='value'>{arc.value}</span>
                    </li>
                ))}
            </ul>
        </div>
    </Fragment>
  )
}

export default StatusRing
